var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isClient)?_c('ClientDashboard',{attrs:{"projectId":_vm.projectId,"user":_vm.user}}):_vm._e(),(_vm.isProvider)?_c('ProviderDashboard',{attrs:{"projectId":_vm.projectId,"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }